import React from 'react'

// TODO: use from @portal/lib/hooks
export function useToggle(initialValue: boolean) {
    const [value, setValue] = React.useState(initialValue)
    const toggleValue = () => setValue(!value)

    return [value, toggleValue] as const
}
